import React from 'react'
import '../estilos/Servicios.css'
import { IconAirConditioningDisabled, IconFileInvoice, IconHammer, IconPuzzle, IconSettings, IconTool, IconWind } from '@tabler/icons-react'
import Carousel from '../helpers/Carousel/Carousel'

function Servicios () {
  const alerimex = [
    require('../img/ALMERIMEX/Imagen1.jpg'),
    require('../img/ALMERIMEX/Imagen2.jpg'),
    require('../img/ALMERIMEX/Imagen3.jpg')
  ]
  const CGGD = [
    require('../img/CGGD/Imagen1.jpg'),
    require('../img/CGGD/Imagen2.jpg'),
    require('../img/CGGD/Imagen3.jpg'),
    require('../img/CGGD/Imagen4.jpg'),
    require('../img/CGGD/Imagen5.jpg'),
    require('../img/CGGD/Imagen6.jpg')
  ]
  const sukarne = [
    require('../img/SUKARNE/Imagen1.jpg'),
    require('../img/SUKARNE/Imagen2.jpg'),
    require('../img/SUKARNE/Imagen3.jpg'),
    require('../img/SUKARNE/Imagen4.jpg'),
    require('../img/SUKARNE/Imagen5.jpg')
  ]
  const car = [
    require('../img/CAR/Imagen1.jpg'),
    require('../img/CAR/Imagen2.jpg'),
    require('../img/CAR/Imagen3.jpg'),
    require('../img/CAR/Imagen4.jpg')
  ]
  const tecmilenio = [
    require('../img/TECMILENIO/Imagen1.jpg'),
    require('../img/TECMILENIO/Imagen2.jpg'),
    require('../img/TECMILENIO/Imagen3.jpg'),
    require('../img/TECMILENIO/Imagen4.jpg'),
    require('../img/TECMILENIO/Imagen5.jpg'),
    require('../img/TECMILENIO/Imagen6.jpg'),
    require('../img/TECMILENIO/Imagen7.jpg')
  ]
  const agro = [
    require('../img/AGROSERVICIOS/Imagen1.jpg'),
    require('../img/AGROSERVICIOS/Imagen2.jpg'),
    require('../img/AGROSERVICIOS/Imagen3.jpg'),
    require('../img/AGROSERVICIOS/Imagen4.jpg'),
    require('../img/AGROSERVICIOS/Imagen5.jpg'),
    require('../img/AGROSERVICIOS/Imagen6.jpg'),
    require('../img/AGROSERVICIOS/Imagen7.jpg'),
    require('../img/AGROSERVICIOS/Imagen8.jpg')
  ]

  return (
    <div className='info'>
      <div className='infotexto'>
        <h2 className='nuestros-servicios'>Nuestros Servicios</h2>
        <section className='services-section'>
          <div className='service'>
            <div className='service-icon'>
              <IconAirConditioningDisabled size={90} stroke={2}></IconAirConditioningDisabled>
            </div>
            <div className='service-description'>
              Minisplit, Multisplit, Unidades paquetes,
              Equipos dividos, Tecnología Inverter.
            </div>
          </div>
          <div className='service'>
            <div className='service-icon'>
              <IconFileInvoice size={90} stroke={2}></IconFileInvoice>
            </div>
            <div className='service-description'>Póliza de mantenimientos.</div>
          </div>
          <div className='service'>
            <div className='service-icon'>
              <IconTool size={90} stroke={2} />
            </div>
            <div className='service-description'>
              Mantenimientos preventivos y correctivos.
            </div>
          </div>
          <div className='service'>
            <div className='service-icon'>
              <IconPuzzle size={90} stroke={2}></IconPuzzle>
            </div>
            <div className='service-description'>Refacciones</div>
          </div>
          <div className='service'>
            <div className='service-icon'>
              <IconWind size={90} stroke={2} />
            </div>
            <div className='service-description'>
              Aire lavado, ducteria, ductos flexibles, accesorios
            </div>
          </div>
          <div className='service'>
            <div className='service-icon'>
              <IconSettings size={90} stroke={2}></IconSettings>
            </div>
            <div className='service-description'>
              Ingenierías, Diseno de cargas termicas
            </div>
          </div>
          <div className='service'>
            <div className='service-icon'>
              <IconHammer size={90} stroke={2}></IconHammer>
            </div>
            <div className='service-description'>Instalacion de ductos de aire</div>
          </div>
        </section>
      </div>
      <div className='infotexto'>
        <h2 className='nuestros-servicios'>Galería de Proyectos</h2>
        <div className="container-projects">
          <Carousel name="Casa de Gobierno" images={CGGD}></Carousel>
          <Carousel name="ALMERIMEX" images={alerimex}></Carousel>
          <Carousel name="SUKARNE" images={sukarne}></Carousel>
          <Carousel name="Centro de Alto Rendimiento" images={car}></Carousel>
          <Carousel name="Universidad Tecmilenio" images={tecmilenio}></Carousel>
          <Carousel name="Agroservicios" images={agro}></Carousel>
        </div>
      </div>
    </div>
  )
}

export default Servicios
